Namespace('MassiveTagging.Views')

class MassiveTagging.Views.MassiveTaggingView extends Backbone.View
  template: JST['backbone/templates/massive_tagging/massive_tagging']

  events:
    'click #confirm': 'update'
    'click #cancel': 'cancel'
    'click #close': 'cancel'

  initialize: ({searchQuery, updateJobClass}) ->
    @searchQuery = searchQuery
    @allPossibleTags = new Collections.UserProfileTagCollection
    @tagsToBeAdded = new MassiveTagging.Views.ChosenTagsView
    @tagsToBeRemoved = new MassiveTagging.Views.ChosenTagsView
    @updateJobClass = updateJobClass
    @onFinish = -> showSuccess(I18n.t('massive_tagging.update_completed'))

  addTags: =>
    tags = @allPossibleTags.pluck('description')
    @tagsToBeAdded.render()
    @tagsToBeAdded.addSelectableTags(tags, I18n.t('massive_tagging.add_tags'))
    @$('.taxonomy-add-tags').append(@tagsToBeAdded.el)
    @tagsToBeRemoved.render()
    @tagsToBeRemoved.addSelectableTags(tags, I18n.t('massive_tagging.remove_tags'))
    @$('.taxonomy-remove-tags').append(@tagsToBeRemoved.el)

  setAddTags: (tags) ->
    @addTagsView.setList(tags)
    @addTagsView.setTagsByClientCode([])
    @addTagsView.render()

  setRemoveTags: (tags) ->
    @removeTagsView.setList(tags)
    @removeTagsView.setTagsByClientCode([])
    @removeTagsView.render()

  onFailure: =>
    document.body.style.cursor = 'default'
    @$el.find('#confirm, #cancel, #close').prop('disabled', false )
    @$el.find('#confirm').addClass('warning').text('Update failed, retry?')
    showError(I18n.t('massive_tagging.update_failed'))

  resetUpdateButton: ->
    @$el.find('#confirm').removeClass('warning').text('Update')

  show: ->
    $(@$el).append(@modalElement) if @modalElement
    @modalElement = ''
    @$el.find('#update_all').modal()

  hide: (shouldClearStatus = true) ->
    @$el.find('#update_all').modal('hide')

  render: ->
    @allPossibleTags.fetch success: @addTags
    @$el.html(@template({
      reached_documents_count: @reached_documents,
      description_translation: I18n.t('massive_tagging.description')
      profiles_translation: I18n.t('massive_tagging.profiles')
      user_profile_tags_translation: I18n.t('massive_tagging.user_profile_tags')
    }))
    @

  update: =>
    title = @reached_documents + ' contents will be updated. Are you sure you want to update them?'
    swal({
      title: title,
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn-info',
      confirmButtonText: 'Yes, update all',
      closeOnConfirm: true
    }, =>
      massive_tagging = {
        add_tags_all: @tagsToBeAdded.selectedOptions(),
        remove_tags_all: @tagsToBeRemoved.selectedOptions(),
      }
      return unless  massive_tagging.add_tags_all or massive_tagging.remove_tags_all
      @hide(true)
      @_sendRequest(_.extend(massive_tagging: massive_tagging, @_searchQueryToSend()))
    )

  cancel: ->
    @hide(false)

  _searchQueryToSend: ->
    notNull(@searchQuery.attributes)

  _sendRequest: (params) ->
    updateJob = new @updateJobClass()
    updateJob.bind('completed', @onFinish)
    updateJob.bind('failed', @onFailure)
    updateJob.start 'massive_tagging', params

  setReachedDocument: (documents_count) ->
    return unless documents_count
    @reached_documents = documents_count
    @render()
